import errorpopup from "assets/icons/errorpopup.svg";
import "./ErrorPopupBtn.scss";
import PropTypes from "prop-types";
import { useEffect, useRef } from "react";
import Icon from "core/icon/Icon";
import { FormattedMessage, useIntl } from "react-intl";

export const ErrorPopup = ({
  showErrorPopup,
  setShowErrorPopup,
  label,
  label: { id: labelId, defaultMessage: labelDefaultMessage },
  errors,
  errorMessage,
  errorValue,
  additionalErrorMessage,
  additionalErrorValue,
}) => {
  const popupRef = useRef();
  const intl = useIntl();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowErrorPopup(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const togglePopup = () => setShowErrorPopup((old) => !old);

  const getErrorContent = () => {
    const msg = errorMessage || errors?.message;
    if (!msg) {
      return intl.formatMessage({ id: "mandatory_input", defaultMessage: "Ce champ est obligatoire." });
    }

    // String = front-end translation key (front-end validation)
    if (typeof msg === "string") {
      return intl.formatMessage({ id: msg, defaultMessage: msg });
    }

    // Object = API error { code, message, params, translationKey }
    const { translationKey, message, params = {} } = msg;

    if (translationKey && intl.messages[translationKey]) {
      return intl.formatMessage({ id: translationKey, defaultMessage: message }, params);
    }

    return message || msg.code || "Erreur inconnue";
  };

  return (
    showErrorPopup && (
      <div className="error-popup-overlay">
        <button className="error-popup-container" onClick={togglePopup}>
          <div className="title-icon-container">
            <div ref={popupRef} className="title-btn">
              <img className="popup-img" src={errorpopup} alt="warning-sign" />
              <div className="popup-title">
                <FormattedMessage
                  id={labelId || label}
                  defaultMessage={labelDefaultMessage}
                />
              </div>
            </div>
            <Icon
              color="error"
              icon="close"
              width={20}
              height={20}
              marginLeft={15}
            />
          </div>
          <div className="popup-content">
            {getErrorContent()}
            {errorValue && <b>{errorValue}</b>}
            <br />
            {additionalErrorMessage && (
              <>
                <FormattedMessage
                  id={additionalErrorMessage}
                  defaultMessage={"Ce champ est obligatoire."}
                />{" "}
                <b>{additionalErrorValue}</b>
              </>
            )}
          </div>
        </button>
      </div>
    )
  );
};

ErrorPopup.propTypes = {
  showErrorPopup: PropTypes.bool,
  setShowErrorPopup: PropTypes.func,
  errors: PropTypes.object,
  label: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
  }),
  errorMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      code: PropTypes.string,
      message: PropTypes.string,
      params: PropTypes.object,
      translationKey: PropTypes.string,
    }),
  ]),
  additionalErrorMessage: PropTypes.string,
  additionalErrorValue: PropTypes.string,
  errorValue: PropTypes.string,
};
